export const linkResolver = (doc: {
  type: string | null;
  uid?: string | null;
}) => {
  /**
   * For preview renderings and error cases
   * Return homepage instead of empty string to prevent redirect issues
   */
  if (!doc?.type) {
    console.warn("[linkResolver] Document type not found!");
    return "/";
  }

  let path = doc.uid?.replace(/_/g, "/");

  if (path && !path.endsWith("/")) path = `${path}/`;

  switch (doc.type) {
    case "page":
    case "page_script":
      if (path === "accueil/") return "/";

      return `/${path}`;

    case "page_landing":
      return `/lp/${path}`;

    default:
      console.warn(`[linkResolver] Unknown document type: ${doc.type}!`);
      return "/";
  }
};
